Object.defineProperty(exports, "__esModule", { value: true });
exports.getProfileImageUrl = exports.REST_API_USER_IMAGE_URL = void 0;
exports.REST_API_USER_IMAGE_URL = '/vizportal/api/rest/v1/userImages/';
function getProfileImageUrl(userImageId) {
    if (!userImageId) {
        return userImageId;
    }
    return exports.REST_API_USER_IMAGE_URL + userImageId;
}
exports.getProfileImageUrl = getProfileImageUrl;
//# sourceMappingURL=UrlBuilder.js.map